module.exports = __webpack_public_path__ + "static/media/DSC_0835.b7ab88ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0835.jpg
// module id = 705
// module chunks = 0